import { Modal } from "bootstrap";
import type { BackdropValue } from "@/Pages/Cases/components/Forms/Mih/stores/modal.store";

export const showModal = ({ modalId, backdrop = true }: { modalId: string; backdrop?: BackdropValue }): void => {
  window.setTimeout(() => {
    const modal = Modal.getOrCreateInstance(`#${modalId}`, { keyboard: true, backdrop });
    modal.show();
  }, 50);
};

export const hideModal = ({ modalId }: { modalId: string }): void => {
  Modal.getInstance(`#${modalId}`)?.hide();
};

export const disposeModal = ({ modalId }: { modalId: string }): void => {
  Modal.getInstance(`#${modalId}`)?.dispose();
};
